import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { useReportSingle } from "../../Hooks";
import Loading from "../../../../../Common/Components/Loading";

function Index() {
  const location = useLocation();
  const { getData, data, loading } = useReportSingle();
  useEffect(() => {
    getData({
      bug_id: location.state && location.state.id,
    });
  }, []);
  return (
    <div className="card">
      <div className="card-body">
        {loading ? (
          <Loading count={1} col={12} height={300} />
        ) : (
          <div>
            <div className="d-flex flex-column justify-content-between">
              <h4>عنوان</h4>
              <h6>{data.title}</h6>
            </div>
            <div className="d-flex flex-column justify-content-between">
              <h4>پیام</h4>
              <p>{data.message}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Index;
